import React from 'react'
import StampDuty from './uploadStampDuty.container'
import View from './viewStamDuty.conatainer';
import { getNbfcList } from '../AdminActionCreator.component';
class MainStamp extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pageViewState: 'View',
            nbfcList: []
        }
    }
    buttonActionHandler(type) {
        this.setState({ pageViewState: type })
    }

    componentDidMount() {
        getNbfcList((callback) => {
            console.log("cal", callback)
            this.setState({ nbfcList: callback })
        })
    }
    
    render() {
        const { admin } = this.props
        return (
            <div>
                <div className="dashboard-tabs">
                    <button style={{ marginLeft: '10px',width:"45%",padding:'2px 5px' }} className={this.state.pageViewState == 'View' ? 'active' : ''} onClick={e => this.buttonActionHandler("View")}>View</button>
                    <button  style={{width:"45%",padding:'2px 5px'}} className={this.state.pageViewState == 'Add' ? 'active' : ''} onClick={e => this.buttonActionHandler("Add")}>Add</button>
                </div>
                {this.state.pageViewState === 'Add' ?
                    <StampDuty admin={admin} 
                    nbfcList={this.state.nbfcList}
                    />
                    : ""}
                {this.state.pageViewState === 'View' ?
                    <View 
                    nbfcList={this.state.nbfcList}/>
                    : ""}
            </div>
        )
    }
}
export default MainStamp